import { useContext } from 'react';
import { ValidatorContext } from '../components/ValidatorContext';
export const useValidator = ()=>{
    const ctx = useContext(ValidatorContext);
    if (!ctx) {
        throw new Error('ValidatorContext is not defined.');
    }
    return ctx;
};
